import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { ReminderDistributionItem } from '../../../../../services/reminder-analytics/reminder-analytics.model';

@Component({
    selector: 'app-reminder-channel-chart',
    templateUrl: './reminder-channel-chart.component.html',
    styleUrls: ['./reminder-channel-chart.component.scss'],
})
export class ReminderChannelChartComponent implements OnChanges {
    @Input() data: ReminderDistributionItem[] = [];

    chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };
    chartOptions: ChartConfiguration<'bar'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
    };

    private channelColors: Record<string, string> = { email: '#3a7bd5', sms: '#10b981', push: '#8b5cf6' };

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((d) => d.label.charAt(0).toUpperCase() + d.label.slice(1)),
            datasets: [{ data: this.data.map((d) => d.count), backgroundColor: this.data.map((d) => this.channelColors[d.label] || '#6b7280'), borderRadius: 4 }],
        };
    }
}
